import BackIcon from '@cp/src/assets/images/icons/BackIcon';
import { useNavigate } from 'react-router-dom';
import cx from 'classnames';
import styles from './segments.module.scss';
import { noop } from '@navi/web-ui/lib/utils/common';
import { DropDownPosition } from '@navi/web-ui/lib/components/Pagination/constant';
import Pagination from '@navi/web-ui/lib/components/Pagination/Pagination';
import AgTable from '@navi/web-ui/lib/components/AgTable/AgTable';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import Button from '@navi/web-ui/lib/primitives/Button/Button';
import PlusIcon from '@cp/src/assets/icons/PlusIcon';
import { useEffect, useState } from 'react';
import CreateSegmentDrawer from './createSegmentDrawer';
import VIEW_PRODUCTS_COL_DEFS from '../Products/Viewproducts/ColumnDefs';
import { useDispatch, useSelector } from 'react-redux';
import { getSegmentsByTenant } from '../paramountActions';
import VIEW_SEGMENTS_COL_DEFS from './viewSegmentsTable';
import useGetTenant from '@cp/pages/Paramount/hooks/useGetTenant';
import { RootState } from '@cp/src/store';
import APP_ROUTES from '@cp/src/layout/Routes';
import CriteriaModal from '@cp/pages/Paramount/Segments/CriteriaModal';

const Segments = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [showSegmentDrawer, setShowSegmentDrawer] = useState(false);
  const handleCreateSegment = () => {
    navigate(`${APP_ROUTES.PARAMOUNT_EDIT_STRATEGY.path}?entity=segment&type=create`);
    setShowSegmentDrawer(true);
  };

  const viewCriteria = (content: string) => {
    setModalContent(content);
    setIsModalOpen(true);
  };
  const columnData = VIEW_SEGMENTS_COL_DEFS(viewCriteria);
  const segments = useSelector((store: RootState) => store.paramountSlice.segments);
  const sortedSegments = [...segments].sort((a, b) => a.id - b.id);

  const tenant = useGetTenant();
  useEffect(() => {
    dispatch(getSegmentsByTenant(tenant));
  }, []);
  return (
    <div className={styles.segmentsPage}>
      <div className={styles.topNavContainer}>
        <div className={cx('cursor-pointer')} onClick={() => navigate(-1)}>
          <BackIcon size={'16'} />
        </div>
      </div>
      <div className="flex flex-row justify-between p-[20px]">
        <Typography variant="h2">Create Segment</Typography>
        <Button
          variant="primary"
          size="medium"
          startAdornment={<PlusIcon fillColor="white" />}
          onClick={handleCreateSegment}
        >
          Create Segment
          <CreateSegmentDrawer
            showUploadDrawer={showSegmentDrawer}
            setShowUploadDrawer={setShowSegmentDrawer}
          />
        </Button>
      </div>
      <CriteriaModal
        showModal={isModalOpen}
        setShowModal={setIsModalOpen}
        modalContent={modalContent}
      />
      <AgTable
        className={styles.segmentsTable}
        columnDefs={columnData}
        rowData={sortedSegments}
        onGridReady={noop}
        defaultColDef={{
          suppressMovable: true,
          wrapText: true
        }}
        style={{
          height: 575,
          width: '97%'
        }}
        sizeColumnsToFit={true}
        theme={'alpine'}
        alternateRowColor="var(--greyscale-content-5)"
        paginationWrapperClasses={'paginationWrapperClasses'}
      />
    </div>
  );
};

export default Segments;
